module.exports = __webpack_public_path__ + "img/collection-weddingRingsMillgrif.8e23aa5.webp";